import React from 'react';
import ConnectPage from '../components/ConnectPage';

const GAdsConnectPage: React.FC = () => {
  const config = {
    serviceName: 'Google Ads',
    serviceDisplayName: 'Google Ads',
    apiBaseUrl: 'https://api.plexhq.ai',
    routePath: '/connect/gads',
    storageKeys: {
      email: 'userEmail',
      returnUrl: 'mcpReturnUrl',
      clientId: 'mcpClientId',
      state: 'mcpState',
      redirectUri: 'mcpRedirectUri',
      codeChallenge: 'mcpCodeChallenge',
    },
    messages: {
      requestAccess: 'Claude is requesting access to your Google Ads data. Click "Connect" to authenticate.',
      directAccessError: 'This page is only accessible through Claude AI. Please add the Google Ads connector in Claude to authenticate.',
      connectDescription: 'Connect your Google Ads account to access your campaigns and data through Claude AI.',
      connectingMessage: 'Connecting...',
      successMessage: 'Successfully connected to Google Ads!',
      errorMessage: 'Failed to connect to Google Ads. Please try again.',
      buttonText: 'Connect Your Google Ads Account',
    },
  };

  return <ConnectPage config={config} />;
};

export default GAdsConnectPage;
